import { FC } from "react";
import { Minus } from "./Minus";
import { Plus } from "./Plus";

interface Props {
  copy: Record<string, string | undefined>;
  isOpen: boolean;
  setIsOpen: any;
}

export const MoreLess: FC<Props> = ({ copy, isOpen, setIsOpen }) => {
  const handleClick = () => {
    const candidateListDiv = document.querySelector(".candidate-list");
    if (candidateListDiv) {
      candidateListDiv.scrollIntoView({ behavior: "smooth" });
    }
    setIsOpen((v: boolean) => !v);
  };
  return (
    <div className="candidate-list__table__more-less">
      <span onClick={handleClick}>
        {isOpen ? (
          <div>
            <Minus /> <span>{copy.candidateListLoadLess}</span>
          </div>
        ) : (
          <div>
            <Plus /> <span>{copy.candidateListLoadMore}</span>
          </div>
        )}
      </span>
    </div>
  );
};
